<template>
    <div class="policy-form-navigator questions_flyout">
        <h3>{{ company.abbreviation || company.name }}</h3>

        <div class="tab-content assessment-questions" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-open" role="tabpanel" aria-labelledby="nav-open-tab">
                <div id="open-accordion">

                    <div class="card" v-for="baa in company.baas">
                        <div class="card-header p-0 section_header">
                            <h5 class="mb-0 d-flex align-items-center">
                                <button :class="`btn btn-link w-100 text-left text-uppercase ${activeBaa.id === baa.id ? 'font-bold' : ''}`" @click.prevent="editBaa(baa.edit_route)">
                                    {{ baa.name }}
                                </button>
                            </h5>
                        </div>
                        <div class="questions_toggle collapse show" v-if="activeBaa.id === baa.id && Object.keys(selectedBaaNavigation).length">
                            <div class="card-body p-0">
                                <ul class="list-group">
                                    <li :class="`list-group-item `" v-for="(navigationItemInputs) in selectedBaaNavigation" v-if="selectedBaaNavigation">
                                        <div class="row">
                                            <div class="text-body col-12">
                                                {{ navigationItemInputs[0].label }}<br />
                                                <div class="question-inputs">
                                                    <template v-for="navigationInput in navigationItemInputs">
                                                        <BaaFormNavigatorInput :navigation-input="navigationInput"></BaaFormNavigatorInput>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header p-0 section_header">
                            <h5 class="mb-0 d-flex align-items-center">
                                <button :class="`btn btn-link w-100 text-left text-uppercase font-bold`" @click.prevent="editBaa(routes.create)">
                                    <i class="fa fa-plus"></i> &nbsp;Create a BAA
                                </button>
                            </h5>
                        </div>
                        <div class="questions_toggle collapse show" v-if="!Object.keys(activeBaa).length && Object.keys(selectedBaaNavigation).length">
                            <div class="card-body p-0">
                                <ul class="list-group">
                                    <li :class="`list-group-item `" v-for="(navigationItemInputs) in selectedBaaNavigation" v-if="selectedBaaNavigation">
                                        <div class="row">
                                            <div class="text-body col-12">
                                                {{ selectedBaa.fields.find(field=>field.slug === navigationItemInputs[0].slug).label }}<br />
                                                <div class="question-inputs">
                                                    <template v-for="navigationInput in navigationItemInputs">
                                                        <BaaFormNavigatorInput :navigation-input="navigationInput"></BaaFormNavigatorInput>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import BaaFormNavigatorInput from './BaaFormNavigatorInput'
    export default {
        name: "BaaFormNavigator",
        props: [
            "routes",
            "company",
            "activeBaa"
        ],
        components: {
            BaaFormNavigatorInput
        },
        data: function(){
            return {
                focusedField: 0
            }
        },
        computed: {
            ...mapState('baaForm',[
                'selectedBaa',
                'selectedBaaNavigation'
            ])
        },
        methods:{
            editBaa(editRoute){
                window.location = editRoute
            },
            focusField(fieldId){
                this.focusedField = fieldId
            },
            fieldIsDisplayed(field){
                console.log(document.getElementById('medcurityBaaBody'))
                return true
            },
            fetchFieldLabel(firstItemInput){
                let baaField = this.selectedBaa.fields.find(field=>field.slug === firstItemInput.originalSlug)
                if(!baaField){
                    console.log(firstItemInput)
                }
                return baaField ? baaField.label : '';
            }
        }
    }
</script>

<style scoped>
    .font-bold{
        font-weight: bold;
    }

    .questions_toggle ul li .text-body{
        font-size: 1.250em;
        color: #6D6E70 !important;
        font-weight: 400;
        padding: 9px 30px 9px 19px;
        display: block;
        line-height: 1.1;
    }
</style>
